var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 3.163l.065-.077-.077-.064L9.489.932 9.413.866l-.065.076-.698.83-.065.076.077.064 2.492 2.091.076.064.064-.076.699-.829zm-7.66-1.25l.076-.064-.064-.077-.693-.828-.065-.077-.076.064-2.492 2.086-.077.064.065.077.699.828.064.077.076-.064 2.487-2.086zm2.538 2.42v-.1H5.858V7.64l.049.03L8.48 9.212l.085.051.052-.085.406-.666.053-.086-.088-.052L6.871 7.12V4.334zM6.5 2.068a4.975 4.975 0 100 9.95 4.975 4.975 0 000-9.95zm0 8.667a3.689 3.689 0 01-3.692-3.692A3.689 3.689 0 016.5 3.35a3.689 3.689 0 013.692 3.692A3.689 3.689 0 016.5 10.734z",
    fill: "#443100",
    stroke: "current",
    className: "clockIcon_svg__stroke-current",
    strokeWidth: 0.2
  })));
}
export default __webpack_public_path__ + "static/media/clockIcon.4b2b7752.svg";
export { SvgClockIcon as ReactComponent };